import { GetterTree } from "vuex";
import { ReservationDetail } from "@/model/ReservationDetail";
import State from "@/store/reservation/state";
// GetterTree<[current state], [root state]>
const getters: GetterTree<State, State> = {
  currentState(state: State): ReservationDetail {
    return state;
  },
  uketsukeCd(state: State): string {
    return state.uketsukeCd;
  },
  uketsukeExtendsId(state: State) {
    return state.uketsukeExtendsId;
  },
  yoyakuNo(state: State): string {
    return state.yoyakuNo;
  },
  frontStaff(state: State): string {
    return state.frontStaff;
  },
  sknUketsukeExtends(state: State) {
    return state.sknUketsukeExtends;
  },
  isLoadUketsuke(state: State) {
    return state.isLoadUketsuke;
  },
  isStart(state: State) {
    return state.isStart;
  },
  shadaiNo(state: State) {
    if (state.customerCar) {
      return state.customerCar.shadaiNo;
    }
    return "";
  },
};

export default getters;
